
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","fill":"#282828","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.18 1.997c2.841.285 5.122 1.995 5.608 4.928h-1.645l2.655 3.95 2.657-3.95h-1.833c-.486-3.95-3.477-6.517-7.255-6.883-.524-.042-1.008.406-1.008.976.035.49.37.937.82.979zM11.067 0H1.832C1.31 0 .898.448.898 1.018v8.798c0 .57.411 1.018.934 1.018h9.235c.523 0 .934-.448.934-1.018V1.018c0-.57-.41-1.018-.934-1.018zM9.271 22.402c-3.178-.286-5.608-2.403-5.72-5.907h1.757l-2.653-3.95L0 16.496h1.757c.074 4.522 3.252 7.454 7.329 7.861.523.04 1.01-.407 1.01-.978a.974.974 0 00-.825-.976zm13.388-8.84h-9.236c-.525 0-.935.45-.935 1.019v8.84c0 .568.41 1.016.934 1.016h9.235c.523 0 .933-.448.933-1.017v-8.839c.002-.569-.446-1.018-.931-1.018z"}})])
          )
        }
      }
    